import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import { ColumnsHelper, CellRendererHelper } from "../../../../containers/AppPage/Reports/ProfitLoss/helper";

const {
    getColClassName,
    getFirstColSpan,
    getSecondColSpan,
} = ColumnsHelper;

const {
    renderCodeCell,
    renderNameCell,
    renderBalanceCell,
    renderPercentageCell,
} = CellRendererHelper;

// Used in CustomizeColumnDrawer
function getColumns() {
    const columns = [
        {
            title: t`Account Code`,
            key: 'code',
            dataIndex: 'code',
            render: null,
        },
        {
            title: t`Account Name`,
            key: 'name',
            dataIndex: 'name',
            render: null,
        },
        {
            title: t`Amount`,
            key: 'amount',
            dataIndex: 'amount',
            render: null,
        },
        {
            title: t`Percentage (%)`,
            key: `percentage`,
            dataIndex: `percentage`,
            render: null,
        },
    ];

    return columns;
}

// Used in Profit & Loss Report
function getDynamicReportColumns(storageKey, storageData, props) {
    const { filterState, reportData, currencySymbol } = props;

    const showAccountCode = storageData.columns.find(col => col.key === 'code');
    const showPercentage = storageData.columns.find(col => col.key === 'percentage');

    let reportColumns = [
        {
            key: 'code',
            dataIndex: 'code',
            width: 120,
            onCell: record => (
                {
                    colSpan: (showAccountCode || record.columnType) ? getFirstColSpan(record.columnType) : 0,
                    className: getColClassName(record.columnType),
                }),
            render: (text, record) => renderCodeCell(text, record, filterState, showAccountCode),
        },
        {
            key: 'name',
            dataIndex: 'name',
            width: 250,
            onCell: record => {
                const isChildren = (record.parent_id && record.parent_id !== 0);

                return {
                    colSpan: (showAccountCode || record.columnType) ? getSecondColSpan(record.columnType) :
                        getSecondColSpan(record.columnType) + getFirstColSpan(record.columnType),
                    className: (
                        getColClassName(record.columnType) +
                            (isChildren ? ' name-indent-col' : '')
                    ),
                };
            },
            render: (text, record) => renderNameCell(text, record, filterState),
        },
    ];

    // add in amount/balance, and % column if selected.
    reportData?.report.column_labels.forEach((item, idx) => {
        reportColumns = reportColumns.concat(
            [renderBalanceCell(item, idx, currencySymbol)],
            showPercentage ? [renderPercentageCell(idx)] : [],
        );
    });

    return reportColumns;
}

export default {
    storageKey: StorageKey.report_profit_loss,
    required: [
        'name',
        'amount',
    ],
    defaulto: [
        'code',
        'percentage',
    ],
    hideTitle: [
        // 'code',
        // 'name',
    ],
    getReportLabel: () => t`Profit & Loss`,
    getColumns,
    getDynamicReportColumns,
};
